import HubSpotService from '@/utils/services/hubspot';

export default {
  install(Vue) {
    // Make HubSpot service available globally
    Vue.prototype.$hubspot = HubSpotService;

    // Add global mixin for UTM tracking
    Vue.mixin({
      created() {
        // Initialize HubSpot on app start
        if (this.$root === this) {
          this.$hubspot.init();

          console.log('HubSpot tracking initialized');
          console.log('UTM Parameters:', this.$hubspot.utmParams);

          if (Object.keys(HubSpotService.utmParams).length > 0) {
            HubSpotService.trackEvent('UTM Parameters Detected', HubSpotService.utmParams);
          }
        }
      }
    });

    // Add router integration if router is available
    if (this.$router) {
      this.$router.afterEach(to => {
        Vue.nextTick(() => {
          HubSpotService.trackPageView(to.name || to.path);
        });
      });
    }
  }
};
